import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store/store';

type TransportOrderDetailState = {
    selectedTransportOrderId: string | null;
};

const initialState: TransportOrderDetailState = {
    selectedTransportOrderId: null,
};

const transportOrderDetailSlice = createSlice({
    name: 'transportOrderDetail',
    initialState,
    reducers: {
        transportOrderDetailOpened: (state, action: PayloadAction<string>) => {
            state.selectedTransportOrderId = action.payload;
        },
        transportOrderDetailClosed: state => {
            state.selectedTransportOrderId = null;
        },
    },
});

export const { transportOrderDetailOpened, transportOrderDetailClosed } = transportOrderDetailSlice.actions;
export const selectTransportOrderDetail = (state: RootState) => state.transportOrderDetail.selectedTransportOrderId;
export default transportOrderDetailSlice.reducer;
